var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currPlatForm === 'PC')?_c('fragment',[_c('section',{class:[
      'headerWrapPC',
      'headerItem_home',
      _vm.isNoBColorheader && _vm.scroll ? 'isNoBColor' : '',
    ],attrs:{"id":"app-header"}},[_c('div',{staticClass:"box_60 flex-row"},[_c('div',{staticClass:"text_55 logo",on:{"click":_vm.logoClick}}),_c('div',{staticClass:"headerWarp"},_vm._l((_vm.title),function(item){return _c('div',{key:item.name,class:['headerItem', { active_bg: item.active }],on:{"click":function($event){return _vm.goto(item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }